import { SvgIcon } from '@mui/material';
import React from 'react';

const BlockColoredIcon = props => {
  return (
    <SvgIcon {...props}>
      <g clipPath="url(#clip0_22864_934)">
        <path
          d="M11.9998 5.33332H11.3332V3.99999C11.3332 2.15999 9.83984 0.666656 7.99984 0.666656C6.15984 0.666656 4.6665 2.15999 4.6665 3.99999V5.33332H3.99984C3.2665 5.33332 2.6665 5.93332 2.6665 6.66666V13.3333C2.6665 14.0667 3.2665 14.6667 3.99984 14.6667H11.9998C12.7332 14.6667 13.3332 14.0667 13.3332 13.3333V6.66666C13.3332 5.93332 12.7332 5.33332 11.9998 5.33332ZM7.99984 11.3333C7.2665 11.3333 6.6665 10.7333 6.6665 9.99999C6.6665 9.26666 7.2665 8.66666 7.99984 8.66666C8.73317 8.66666 9.33317 9.26666 9.33317 9.99999C9.33317 10.7333 8.73317 11.3333 7.99984 11.3333ZM10.0665 5.33332H5.93317V3.99999C5.93317 2.85999 6.85984 1.93332 7.99984 1.93332C9.13984 1.93332 10.0665 2.85999 10.0665 3.99999V5.33332Z"
          fill={props.color}
        />
      </g>
      <defs>
        <clipPath id="clip0_22864_934">
          <rect width="16" height="16" fill="white" />
        </clipPath>
      </defs>
    </SvgIcon>
  );
};

export default BlockColoredIcon;
